import dom, { Fragment } from "../../dist/jsx-render/dom";
import { ComponentBase } from "./ComponentBase";
import { app } from "../Frame/App";
import { RadioButtonComponent } from "./RadioButtonComponent";
import { DateControl } from "../BindingControls/DateControl";
import { Controller as BindingController } from "../BindingControls/Controller";
import { FieldDropdownComponent } from "./Dropdowns/FieldDropdownComponent";
import { Template } from "../Areas/Admin/Measures/TemplateEdit/Models/Template";
import { TemplateFieldTypes } from "../Areas/Admin/Shared/Models/TemplateFieldTypes";
import { TextComponent } from "./TextComponent";

export type DateFieldComponentProps = {
    model: any;
    template: Template;

    /** If this is true, the value is saved as a Date Object and not as a string. */
    useDate?: boolean;

    /** Show the option "Date functions" (e.g. to use {today}) */
    useDateFunctions?: boolean;

    /** Show the option "Field" (to set the value of another field, used in ) */
    useField?: boolean;

    changeEvent?: () => void;
}

export class DateFieldComponent extends ComponentBase {
    constructor(props: DateFieldComponentProps) { super(props); }
    props: DateFieldComponentProps;

    clientId: string = app.createGuid();
    dateControlId: string;


    render() {
        this.dateControlId = `dateControl_${this.clientId}`;

        let options = [
            { description: Resources.Common.fromDate, value: 0 }
        ];

        if (this.props.useField) {
            options.push({ description: Resources.Common.fromFields, value: 1 });
        }

        if (this.props.useDateFunctions) {
            options.push({ description: Resources.Common.fromDateFunction, value: 2 });
        }

        let radioButtonDefaultValue: string;
        if (this.props.model.dateFunction) {
            radioButtonDefaultValue = "2";
        } else if (this.props.model.dateValue) {
            radioButtonDefaultValue = "0";
        }

        let element = <div class="form-group">
            <RadioButtonComponent
                isMultiFieldMappingForStringValues={true}
                options={options}
                inline={true}
                changeEvent={this.onItemTypeSelected}
                name={Resources.Common.value}
                defaultValue={radioButtonDefaultValue} />
            <div id={this.dateControlId}>
            </div>
        </div>

        let dateControl = element.querySelector("#" + this.dateControlId) as HTMLInputElement;

        if (this.props.model.dateValue) {
            let inputElement = <input class="form-control"></input>;
            this.createDatePicker(inputElement);

            dateControl.appendChild(inputElement);
        } else if (this.props.model.dateFunction) {
            dateControl.appendChild(<TextComponent
                model={this.props.model}
                field="dateFunction"
                name={Resources.Common.fromDateFunction}
                showTooltip={true}
                infoText={Resources.Common.fromDateFunctionInfo} />);
        } else if (this.props.model.value > 0) {
            let fieldTypes: TemplateFieldTypes[] = [
                TemplateFieldTypes.Datum,
                TemplateFieldTypes.BlockDate,
                TemplateFieldTypes.ParentContentDate,
                TemplateFieldTypes.BlockFinished
            ]

            let dataFromSubmeasureFields = JSON.parse((document.getElementById("hiddenDataFromSubmeasureFields") as HTMLInputElement).value);

            dateControl.appendChild(<FieldDropdownComponent
                field="value"
                model={this.props.model}
                template={this.props.template}
                templateFieldTypes={fieldTypes}
                checkSubmeasureTypes={true}
                dataFromSubmeasureList={dataFromSubmeasureFields}
            />);
        }

        return (element);

    }

    onItemTypeSelected = (event: Event) => {
        let dateControl = document.getElementById(this.dateControlId) as HTMLInputElement;
        app.destroyDomChildren(dateControl);

        let value = (event.target as HTMLInputElement).value;
        this.createControls(value, dateControl);
    }


    private createControls(value: string, dateControl: HTMLInputElement) {
        if (value == "1") {
            this.props.model.dateValue = "";
            this.props.model.value = "";
            this.props.model.dateFunction = undefined;

            let fieldTypes: TemplateFieldTypes[] = [
                TemplateFieldTypes.Datum,
                TemplateFieldTypes.BlockDate,
                TemplateFieldTypes.ParentContentDate,
                TemplateFieldTypes.BlockFinished
            ];

            let dataFromSubmeasureFields = JSON.parse((document.getElementById("hiddenDataFromSubmeasureFields") as HTMLInputElement).value);

            dateControl.appendChild(<FieldDropdownComponent
                field="value"
                model={this.props.model}
                template={this.props.template}
                templateFieldTypes={fieldTypes}
                checkSubmeasureTypes={true}
                dataFromSubmeasureList={dataFromSubmeasureFields} />);
        }
        else if (value == "0") {
            this.props.model.value = 0;
            this.props.model.dateFunction = undefined;

            let inputElement = <input class="form-control"></input>;
            this.createDatePicker(inputElement);

            dateControl.appendChild(inputElement);
        }
        else if (value == "2") {
            this.props.model.dateValue = "";
            this.props.model.value = "";

            dateControl.appendChild(<TextComponent
                model={this.props.model}
                field="dateFunction"
                name={Resources.Common.fromDateFunction}
                showTooltip={true}
                infoText={Resources.Common.fromDateFunctionInfo + " {today} {null}"} />);
        }
    }

    private createDatePicker(inputElement: any) {
        let datePicker = new DateControl(inputElement, new BindingController(null, true), "dateValue");
        datePicker.setModel(this.props.model);
        datePicker.postSaveValue = () => {
            if (this.props.changeEvent) {
                this.props.changeEvent();
            }
        };

        if (this.props.useDate === true) {
            datePicker.useDateType = true;
        }
    }

    dispose() { }
    validate() { }
}